import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
 import messageAlertSound from "../../assets/audio/message.mp3";
 import axiosInstance from "../../../axiosInstance";
import getDecryptData from "../../../helper/getDecryptData";
import { useBlogContext } from "../../../fetchdata/BlogContext";
import Header from "../../components/Header";

const AccountChat = () => {
  const { sendMessage, AllMessages } = useBlogContext();

  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const { userId } = useParams();

  const decryptdatajson = getDecryptData();
  const senderId = decryptdatajson._id;
  const [audio] = useState(new Audio(messageAlertSound)); // Create an Audio object with the sound file
  const [messagesData, setMessagesData] = useState([]);

  const [User, setUser] = useState([]);
  const [Loading, setLoading] = useState(true);

  useEffect(() => {
    //form handle
 

    const fetchUserById = async () => {
      try {
        const response = await axiosInstance.get(
          `/get-message/${userId}/${senderId}/`
        );
        const { messages, success,user } = response.data;
        if (success) {
          console.log(messages);
          setMessagesData(messages);
          setUser(user);

        }
      } catch (error) {
        console.error("Error fetching messages:", error);
      } finally {
        setLoading(false);
        setTimeout(() => {
          scrollToBottom();
        }, 100);
      }
    };

    fetchUserById();
    // fetchUsernameById();
  }, []);

  useEffect(() => {
    setMessages(AllMessages);
    scrollToBottom(); // Scroll to the bottom of the chat box whenever messages are updated

    console.log(AllMessages);
  }, [AllMessages]);

  const handleMessageSubmit = async (e) => {
    e.preventDefault();
    const sendmsg = {
      text: messageInput,
      userId: userId,
      senderId: senderId,
      type: "message",
        username : decryptdatajson.username ?? 'anonymous',
        profile: User.profile ?? '',
    };
    sendMessage(sendmsg);
    // socket.emit('chat message', { text: messageInput, userId:userId,senderId:senderId });
    setMessageInput("");
    scrollToBottom(); // Scroll to the bottom of the chat box whenever messages are updated

    try {
      const { data } = await axiosInstance.post(`/add-message`, {
        text: messageInput,
        userId: userId,
        senderId: senderId,
      
       });
      const { success } = data;
      console.log("data data", data);
      if (success) {
        toast.success("message Send Sucessfully");
      }
    } catch (error) {
      console.error("Error On Profile:", error);
       toast.error(error.response.data.message);
    }
  };

  const playMessageAlert = () => {
    const audio = new Audio(messageAlertSound);
    audio.play();
  };

  const scrollToBottom = () => {
    const scrollOffset = 1600000; // Adjust the scroll offset as needed
    window.scrollTo({
      top: document.body.scrollHeight + scrollOffset,
      behavior: "smooth",
    }); // Scroll to the bottom of the page with an additional offset
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      month: "long", // Use 'long' to display the full month name
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };
  return (
    <>
   <div className="d-flex flex-column">

  <header class="d-flex align-items-center bg-white p-3 sticky-top border-bottom">
    <Link class="btn btn-dark me-3" to={'/account/friends'}>
      <i class="ri-arrow-left-line"></i> Back
    </Link>
    <div>
      <h5 class="mb-0">{User.username ?? 'anonymous user'}</h5>
      {/* <small class="text-muted">Product Designer @ OnTech</small> */}
    </div>
  </header>

<div className="container py-3" style={{height:'100%',flex:1}}>
  {/* Chat Container */}
  <div
    style={{height:'100%'}}
   
  >

      {Loading ? (
              <>
                   <div className="d-flex justify-content-end">
                   <div
                    className="skeleton"
                    style={{ height: 40, width: 150 }}
                  />
                  </div>
               

                 <div className="d-flex justify-content-start">
                   <div
                    className="skeleton"
                    style={{ height: 40, width: 150 }}
                  />
                  </div>


   <div className="d-flex justify-content-end">
                   <div
                    className="skeleton"
                    style={{ height: 40, width: 150 }}
                  />
                  </div>
               

                 <div className="d-flex justify-content-start">
                   <div
                    className="skeleton"
                    style={{ height: 40, width: 150 }}
                  />
                  </div>


                     <div className="d-flex justify-content-end">
                   <div
                    className="skeleton"
                    style={{ height: 40, width: 150 }}
                  />
                  </div>
               

                 <div className="d-flex justify-content-start">
                   <div
                    className="skeleton"
                    style={{ height: 40, width: 150 }}
                  />
                  </div>




                     <div className="d-flex justify-content-end">
                   <div
                    className="skeleton"
                    style={{ height: 40, width: 150 }}
                  />
                  </div>
               

                 <div className="d-flex justify-content-start">
                   <div
                    className="skeleton"
                    style={{ height: 40, width: 150 }}
                  />
                  </div>
                
                
                     <div className="d-flex justify-content-end">
                   <div
                    className="skeleton"
                    style={{ height: 40, width: 150 }}
                  />
                  </div>
               

                 <div className="d-flex justify-content-start">
                   <div
                    className="skeleton"
                    style={{ height: 40, width: 150 }}
                  />
                  </div>

                  
                     <div className="d-flex justify-content-end">
                   <div
                    className="skeleton"
                    style={{ height: 40, width: 150 }}
                  />
                  </div>
               

                 <div className="d-flex justify-content-start">
                   <div
                    className="skeleton"
                    style={{ height: 40, width: 150 }}
                  />
                  </div>
                  
                 
              </>
            ) : (
            messagesData &&  messagesData.map((message, index) => (
         
    <div  key={index} className={`d-flex ${message.receiver === userId ? "justify-content-end" : "justify-content-start"}  mb-3`}>
   <div >
       <div
        className="bg-primary text-white p-3 rounded-3"
        style={{ maxWidth: "70%", borderTopRightRadius: 0 }}
      >
       {message.text} 
      </div>
       <div className="message-time small">
                      {formatTimestamp(message.createdAt)}
                    </div>
                         </div>
    </div>
                 
              ))
            )}

            {messages && messages.map(
              (message, index) =>
                 (
                      <div  key={index} className={`d-flex ${message.senderId === senderId ? "justify-content-end" : "justify-content-start"}  mb-3`}>
   <div >
       <div
        className="bg-primary text-white p-3 rounded-3"
        style={{ maxWidth: "70%", borderTopRightRadius: 0 }}
      >
       {message.text} 
      </div>
       <div className="message-time small">
                      { message.time}
                    </div>
                         </div>
    </div>
             
                )
            )}
            

 
  </div>

</div>
   {/* Message Input */}
 <form onSubmit={handleMessageSubmit} className="input-group sticky-bottom bg-white p-3 border-top">
  <input
    type="text"
    className="form-control"
    id="chat-input"
    placeholder="Type a message..."
    value={messageInput}
    onChange={(e) => setMessageInput(e.target.value)}
  />
  <button
    className="btn btn-primary"
    id="send-btn"
    type="submit"  // Set the button type to 'submit' so it triggers form submission
  >
    <i className="bi bi-send" />
  </button>
</form>

    
   </div>
    
    </>
  );
};

export default AccountChat;
